import { render, staticRenderFns } from "./FlavourChoice.vue?vue&type=template&id=05a7b64c&"
import script from "./FlavourChoice.vue?vue&type=script&lang=js&"
export * from "./FlavourChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports